import {
  LOAD_CONFIGURATION, 
  SITE_SELECTED,
  LOG_OUT,
  LOG_IN,
} from '../constants/ActionTypes'
import _ from 'lodash';
import ISPyB from '../config/config.js';

const initialState =  { sites : [], beamlines : {MX : []}, dataAnalysis : {}, settings : {}, isSAXSenabled : false, isMXenabled : false, isEMenabled : false}   

const configuration = (state = initialState, action) => {  
      
  
  switch (action.type) {

    case LOG_IN: {                   
      let beamlines = _.find(ISPyB.sites, { name : action.site}).beamlines;
      state = {...state,  
                  beamlines     : beamlines,
                  settings      : _.find(ISPyB.sites, { name : action.site}).settings, 
                  dataAnalysis  : _.find(ISPyB.sites, { name : action.site}).dataAnalysis,
                  isSAXSenabled :  (beamlines.SAXS && beamlines.SAXS.length > 0) == true,
                  isMXenabled   :  (beamlines.MX && beamlines.MX.length > 0) == true,
                  isEMenabled   :  (beamlines.EM && beamlines.EM.length > 0) == true
                }; 
      break;
    }

    case LOAD_CONFIGURATION : {  
        if (action.payload){         
          state = {...state,  sites : action.payload};
        } 
        else{
          state = {...state,  sites : []};
        }     
        break;
    } 
    case SITE_SELECTED:{
      alert(action.payload)
    }
    case LOG_OUT: {        
      //state = {beamlines : null, dataAnalysis : {}};   
      break;  
    }
    default:
        break;
  }
  return state
}

export default configuration;



// WEBPACK FOOTER //
// ./src/reducers/configuration.js